import { ROUTES } from "@/routes";
import type { ImportPageState } from "./bpaImport";
import type { ImportPurpose } from "./bpaImportUrlState";

export function cancelDestination(args: {
  purpose: ImportPurpose | null;
  hub: string | null;
  targetEditionId: string;
  targetBpaId: string;
}): string {
  if (args.purpose && args.hub) return args.hub;
  return ROUTES.research.cmsBpa(args.targetEditionId, args.targetBpaId);
}

function sortedEntries<T>(map: Record<string, T> | undefined): [string, T][] {
  return Object.entries(map ?? {}).sort(([a], [b]) => a.localeCompare(b));
}

function withoutEmptyFirms<T extends object>(
  map: Record<string, T> | undefined,
): Record<string, T> {
  return Object.fromEntries(
    sortedEntries(map).filter(([, value]) => Object.keys(value).length > 0),
  );
}

function comparable(state: ImportPageState) {
  return {
    sourceEditionBpaId: state.sourceEditionBpaId,
    kinds: [...state.kinds].sort(),
    mode: state.mode,
    unticked: [...state.unticked].sort(),
    choices: Object.fromEntries(sortedEntries(state.choices)),
    itemChoices: Object.fromEntries(
      sortedEntries(withoutEmptyFirms(state.itemChoices)).map(([firm, items]) => [
        firm,
        Object.fromEntries(sortedEntries(items)),
      ]),
    ),
    clicked: Object.fromEntries(
      sortedEntries(withoutEmptyFirms(state.clicked)).map(([firm, ids]) => [firm, [...ids].sort()]),
    ),
  };
}

export function isImportDirty(opened: ImportPageState, current: ImportPageState): boolean {
  return JSON.stringify(comparable(opened)) !== JSON.stringify(comparable(current));
}
